import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  createClinicLabProfile,
  getAllClinicLabProfile,
  resetCreateClinicTestProfileMessage,
  resetDeleteTestinClinicLabProfileMessage,
  deleteTestFromClinicLabProfile,
  getClinicLabProfileByProfileId,
  updateClinicLabProfile,
  deletedClinicLabProfile,
  resetDeleteClinicTestProfileMessage,
  resetUpdateClinicTestProfileMessage,
} from "../../../store/slices/clinicLabProfile";
import { Modal } from "react-bootstrap";
import {
  showToastifySuccess,
  showToastifyError,
} from "../../common/tostify/Toastifyresponse";
import classNames from "classnames";
import AddUpdateClinicTestProfile from "./addUpdateClinicLabProfile";
import styles from "../clinicLabProfile/clinicLabProfile.module.scss";
import { RiProfileLine } from "react-icons/ri";
import { FaChevronRight } from "react-icons/fa6";
import { TbTestPipe } from "react-icons/tb";
import { Link } from "react-router-dom";
import { Dropdown } from "react-bootstrap";
import { FaSearch } from "react-icons/fa";
import { getClinicTestMasterByClinicId } from "../../../store/slices/clinicTestMaster";
import ViewAllTest from "./viewAllTest";
import { getCategorySlice } from "../../../store/slices/categorySlice";
import ShowTostifyMessageAndReset from "../../common/showTostifyMessageAndReset/showTostifyMessageAndReset";
import { getTestSampleTypeSlice } from "../../../store/slices/testSampleTypeSlice";
import { getAllTestmethod } from "../../../store/slices/testMethodSlice";

const ClinicLabProfile = () => {
  const [modalVisible, setModalVisible] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [viewAllclinicTestProfile, setViewAllclinicTestProfile] =
    useState(false);
  const [selectedAction, setSelectedAction] = useState("Create");
  const { userInfo, token } = useSelector((state) => state.auth);
  const { clinicInfo } = useSelector((state) => state.clinic);
  const { categories } = useSelector((state) => state.category);
  const { testSampleType } = useSelector((state) => state.testSampleType);
  const { testMethod } = useSelector((state) => state.testMethod);

  const clinicId = clinicInfo?.[0]?.clinicId;
  const clinicObjId = clinicInfo?.[0]?._id;
  const initialState = {
    id: "",
    profileName: "",
    testList: [],
    testName: "",
    category: "",
    clinicId: "",
    categoryName: "",
    clientPrice: "",
    pt_price: "",
    tax: "",
    createdBy: clinicObjId,
    status: "Active",
    testSampleType: "",
    testSampleTypeName: "",
    testMethod: "",
    testMethodName: "",
  };
  const [inputError, setInputError] = useState({
    text: false,
    onlyNumber: false,
  });
  const [clinicTestProfileFormData, setClinicTestProfileFormData] =
    useState(initialState);
  const [searchValue, setSearchValue] = useState("");
  const dispatch = useDispatch();
  const showTostifyMessageAndReset = ShowTostifyMessageAndReset();
  const {
    searchMessage,
    createClinicTestProfileSuccessMessage,
    createClinicTestProfileErrorMessage,
    updateClinicTestProfileSuccessMessage,
    updateClinicTestProfileErrorMessage,
    clinicTestProfile,
    clinicLestProfileDetails,
    deleteTestinClinicLabProfileSuccessMessage,
    deleteTestinClinicLabProfileErrorMessage,
    deleteClinicTestProfileSuccessMessage,
    deleteClinicTestProfileErrorMessage,
  } = useSelector((state) => state.clinicLabProfile);
  const { clinicTestMasterByClinicId } = useSelector(
    (state) => state.clinicTestMaster,
  );

  useEffect(() => {
    dispatch(getCategorySlice({ status: ["Active"], token }));
    dispatch(getTestSampleTypeSlice({ token }));
    dispatch(getAllTestmethod({ token }));
  }, [dispatch, viewAllclinicTestProfile, deleteModal, modalVisible, token]);
  useEffect(() => {
    dispatch(
      getAllClinicLabProfile({
        clinicId,
        token,
        status: ["Active", "Inactive"],
      }),
    );
    dispatch(getClinicTestMasterByClinicId({ clinicId, token }));
  }, [
    dispatch,
    viewAllclinicTestProfile,
    deleteModal,
    modalVisible,
    userInfo,
    clinicInfo,
    token,
  ]);

  useEffect(() => {
    showTostifyMessageAndReset(
      createClinicTestProfileSuccessMessage,
      showToastifySuccess,
      resetCreateClinicTestProfileMessage,
    );
    showTostifyMessageAndReset(
      createClinicTestProfileErrorMessage,
      showToastifyError,
      resetCreateClinicTestProfileMessage,
    );
    showTostifyMessageAndReset(
      updateClinicTestProfileSuccessMessage,
      showToastifySuccess,
      resetUpdateClinicTestProfileMessage,
    );
    showTostifyMessageAndReset(
      updateClinicTestProfileErrorMessage,
      showToastifyError,
      resetUpdateClinicTestProfileMessage,
    );
    showTostifyMessageAndReset(
      deleteTestinClinicLabProfileSuccessMessage,
      showToastifySuccess,
      resetDeleteTestinClinicLabProfileMessage,
    );
    showTostifyMessageAndReset(
      deleteTestinClinicLabProfileErrorMessage,
      showToastifyError,
      resetDeleteTestinClinicLabProfileMessage,
    );
    showTostifyMessageAndReset(
      deleteClinicTestProfileSuccessMessage,
      showToastifySuccess,
      resetDeleteClinicTestProfileMessage,
    );
    showTostifyMessageAndReset(
      deleteClinicTestProfileErrorMessage,
      showToastifyError,
      resetDeleteClinicTestProfileMessage,
    );
  }, [
    createClinicTestProfileSuccessMessage,
    createClinicTestProfileErrorMessage,
    updateClinicTestProfileSuccessMessage,
    updateClinicTestProfileErrorMessage,
    dispatch,
    deleteTestinClinicLabProfileSuccessMessage,
    deleteTestinClinicLabProfileErrorMessage,
    deleteClinicTestProfileSuccessMessage,
    deleteClinicTestProfileErrorMessage,
    showTostifyMessageAndReset,
  ]);

  const handleSetClinicTestProfileFormData = (e, names) => {
    if (names === "tests") {
      const selectedOptions = e || [];
      const selectedValues = selectedOptions.map((option) => ({
        value: option.value,
        label: option.label,
      }));
      setClinicTestProfileFormData({
        ...clinicTestProfileFormData,
        testList: selectedValues,
      });
    } else if (names === "categories") {
      setClinicTestProfileFormData({
        ...clinicTestProfileFormData,
        category: e.value,
        categoryName: e.label,
      });
    } else if (names === "testSampleType") {
      setClinicTestProfileFormData({
        ...clinicTestProfileFormData,
        testSampleType: e.value,
        testSampleTypeName: e.label,
      });
    } else if (names === "testMethod") {
      setClinicTestProfileFormData({
        ...clinicTestProfileFormData,
        testMethod: e.value,
        testMethodName: e.label,
      });
    } else {
      setClinicTestProfileFormData({
        ...clinicTestProfileFormData,
        [e.target.name]: e.target.value,
        clinicId,
        createdBy: clinicObjId,
      });
    }
  };

  const handleAddOrUpdateTestProfile = async (e) => {
    e.preventDefault();
    const { text, onlyNumber } = inputError;
    if (text || onlyNumber) return;
    const newTestList = clinicTestProfileFormData.testList.map(
      (item) => item.value,
    );
    try {
      if (selectedAction === "Create") {
        await dispatch(
          createClinicLabProfile({
            ...clinicTestProfileFormData,
            tests: newTestList,
            token,
          }),
        );
      } else {
        await dispatch(
          updateClinicLabProfile({
            ...clinicTestProfileFormData,
            tests: newTestList,
            updatedBy: clinicObjId,
            token,
          }),
        );
      }
      setModalVisible(false);
    } catch (err) {
      console.error(err);
    }
  };
  const handleEditClinicLabProfile = (data) => {
    setModalVisible(true);
    setSelectedAction("Update");
    const mappedTests = data?.tests?.map((test) => ({
      value: test._id,
      label: test.testName,
    }));
    setClinicTestProfileFormData({
      profileId: data?._id,
      profileName: data?.profileName,
      testList: mappedTests,
      clinicId: data?.clinicId?._id,
      clinicName: data?.clinicId?.userId?.name,
      category: data?.category?._id,
      categoryName: data?.category?.categoryName,
      clientPrice: data?.clientPrice || "",
      pt_price: data?.pt_price || "",
      tax: data?.tax || "",
      status: data?.status || "Active",
      updatedBy: clinicObjId,
      testSampleType: data?.testSampleType?._id,
      testSampleTypeName: data?.testSampleType?.name,
      testMethod: data?.testMethod?._id,
      testMethodName: data?.testMethod?.name,
    });
  };

  const handleDeleteClick = (id) => {
    setDeleteModal(true);
    setClinicTestProfileFormData((prevFormData) => ({
      ...prevFormData,
      id,
    }));
  };

  const handleConfirmDelete = async (e) => {
    e.preventDefault();
    try {
      await dispatch(
        deletedClinicLabProfile({
          profileId: clinicTestProfileFormData.id,
          token,
        }),
      );
      setDeleteModal(false);
      dispatch(
        getAllClinicLabProfile({
          clinicId,
          token,
          status: ["Active", "Inactive"],
        }),
      );
    } catch (err) {
      console.error(err);
    }
  };

  const handleModal = () => {
    setSelectedAction("Create");
    setModalVisible(true);
    setClinicTestProfileFormData(initialState);
  };

  const handleSearch = (e) => {
    setSearchValue(e.target.value);
    dispatch(
      getAllClinicLabProfile({
        clinicId,
        searchQuery: e.target.value,
        token,
        status: ["Active", "Inactive"],
      }),
    );
  };

  const heading = () => (
    <div className="form-head d-flex mb-3 mb-md-4 align-items-start">
      <div className="me-4 d-none d-lg-block">
        <div
          className="btn btn-primary btn-rounded"
          onClick={() => handleModal()}
        >
          + Add
        </div>
      </div>
      <div className="input-group search-area ms-auto d-inline-flex me-3">
        <input
          type="text"
          className="form-control"
          placeholder="Search here"
          value={searchValue}
          onChange={handleSearch}
        />
        <div className="input-group-append">
          <button type="button" className="input-group-text">
            <FaSearch className="flaticon-381-search-2" />
          </button>
        </div>
      </div>
    </div>
  );
  const clinicTestProfileList = () => (
    <div className="row">
      {clinicTestProfile &&
        clinicTestProfile.map((item, index) => (
          <div
            className="col-xl-3 col-xxl-4 col-lg-6 col-md-6 col-sm-6"
            key={index}
          >
            <div className="card project-boxed">
              <div
                className={classNames(
                  styles.titel,
                  "card-header",
                  "align-items-start",
                )}
              >
                <div className={styles.titelWrapper}>
                  <RiProfileLine />
                  <h6 className="fs-18 font-w500">
                    <Link to={"#"} className="text-black user-name">
                      {item?.profileName}
                    </Link>
                  </h6>
                </div>
                <Dropdown className="">
                  <Dropdown.Toggle
                    variant=""
                    as="div"
                    className="btn-link i-false"
                  >
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z"
                        stroke="#342E59"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z"
                        stroke="#342E59"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z"
                        stroke="#342E59"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </Dropdown.Toggle>
                  <Dropdown.Menu align={"end"}>
                    <Dropdown.Item
                      onClick={() => handleEditClinicLabProfile(item)}
                    >
                      Edit
                    </Dropdown.Item>
                    <Dropdown.Item
                      className="text-danger"
                      onClick={() => handleDeleteClick(item._id)}
                    >
                      Delete
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
              <div className="card-body p-0 pb-3">
                <ul className="list-group list-group-flush">
                  <li className={classNames(styles.list, "list-group-item")}>
                    <span className="mb-0 title">clinic Name</span> :
                    <span className="text-black ms-2">
                      {item?.clinicId?.userId?.name}
                    </span>
                  </li>
                  <li className={classNames(styles.list, "list-group-item")}>
                    <span className="mb-0 title">Client Price</span> :
                    <span className="text-black ms-2">{item?.clientPrice}</span>
                  </li>
                  <li className={classNames(styles.list, "list-group-item")}>
                    <span className="mb-0 title">Patient Price</span> :
                    <span className="text-black ms-2">{item?.pt_price}</span>
                  </li>
                  <li className={classNames(styles.list, "list-group-item")}>
                    <span className="mb-0 title">Tax</span> :
                    <span className="text-black ms-2">{item?.tax}</span>
                  </li>
                  <li className={classNames(styles.list, "list-group-item")}>
                    <span className="mb-0 title">Status</span> :
                    <span className="text-black ms-2">{item?.status}</span>
                  </li>
                  <b className={styles.clinicName}>Test Names:</b>
                  {item?.tests &&
                    item?.tests.slice(0, 2).map((test, index) => (
                      <li
                        className={classNames(styles.list, "list-group-item")}
                        key={index}
                      >
                        <TbTestPipe className="ms-2" />
                        <span className="text-black ms-2">
                          {test?.testName}
                        </span>
                      </li>
                    ))}
                  <li className={classNames(styles.list, "list-group-item")}>
                    <b className="mb-0 title">
                      +
                      {item?.tests?.length < 2
                        ? item?.tests?.length
                        : item?.tests?.length - 2}{" "}
                      More Tests
                    </b>
                  </li>
                  <div
                    className={styles.viewMoreWrapper}
                    onClick={() => handleViewAllclinicTestProfile(item?._id)}
                  >
                    <p>
                      View All Tests <FaChevronRight />
                    </p>
                  </div>
                </ul>
              </div>
            </div>
          </div>
        ))}
    </div>
  );

  const handleViewAllclinicTestProfile = (value) => {
    dispatch(getClinicLabProfileByProfileId({ profileId: value, token }));
    setViewAllclinicTestProfile(true);
  };

  const handleDeleteTest = async (value) => {
    await dispatch(
      deleteTestFromClinicLabProfile({
        clinicId: clinicLestProfileDetails?.clinicId?._id,
        testId: value,
        clinicLabProfileId: clinicLestProfileDetails?._id,
        token,
      }),
    );
    await dispatch(
      getAllClinicLabProfile({
        clinicId: clinicLestProfileDetails?.clinicId?._id,
        status: ["Active", "Inactive"],
        token,
      }),
    );
    await dispatch(
      getClinicLabProfileByProfileId({
        profileId: clinicLestProfileDetails?._id,
        token,
      }),
    );
    setViewAllclinicTestProfile(true);
  };

  return (
    <>
      {heading()}
      {clinicTestProfile && clinicTestProfile.length > 0 ? (
        clinicTestProfileList()
      ) : (
        <h5 className="text-center mt-5">{searchMessage}</h5>
      )}
      <ViewAllTest
        handleDeleteTest={handleDeleteTest}
        clinicLestProfileDetails={clinicLestProfileDetails}
        setViewAllclinicTestProfile={setViewAllclinicTestProfile}
        viewAllclinicTestProfile={viewAllclinicTestProfile}
        handleConfirmDelete={handleConfirmDelete}
      />
      {/* Add and Update Country Modal */}
      <AddUpdateClinicTestProfile
        modalVisible={modalVisible}
        setModalVisible={setModalVisible}
        clinicTestProfileFormData={clinicTestProfileFormData}
        handleAddOrUpdateTestProfile={handleAddOrUpdateTestProfile}
        selectedAction={selectedAction}
        handleSetClinicTestProfileFormData={handleSetClinicTestProfileFormData}
        clinicTestMasterByClinicId={clinicTestMasterByClinicId}
        categories={categories}
        setInputTextError={setInputError}
        testSampleType={testSampleType}
        testMethod={testMethod}
      />
      {/* Add and Update Country Modal end */}
      {/* delete Modal */}
      <Modal
        centered
        show={deleteModal}
        onHide={() => setDeleteModal(false)}
        size={"md"}
      >
        <div className="modal-header">
          <h5 className="modal-title" id="exampleModalLabel">
            Confirm Delete
          </h5>
          <button
            type="button"
            className="btn-close"
            onClick={() => setDeleteModal(false)}
          ></button>
        </div>
        <div className="modal-body">
          <p>
            Are you sure you want to delete the Test Master{" "}
            <strong className="text-dark">
              {clinicTestProfileFormData?.testName}
            </strong>
            ?
          </p>
        </div>
        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-secondary"
            onClick={() => setDeleteModal(false)}
          >
            Cancel
          </button>
          <button
            type="button"
            className="btn btn-danger"
            onClick={handleConfirmDelete}
          >
            Delete
          </button>
        </div>
      </Modal>
    </>
  );
};

export default ClinicLabProfile;
